import { useMemo } from 'react';
import { Stack, Grid } from '@mui/material';

import { InfoField, NO_DATA_PLACEHOLDER, Typography } from '@occc-app/design-system';
import { LocationAddressFragment } from '@occc/graphql';
import { formatPhoneNumberNationalForUS } from '@occc/utils-phone-number';
import { formatFullAddress } from '@occc/utils-formatters';

type LocationAddressCardProps = {
  address?: LocationAddressFragment | null;
  phoneNumbers: string[];
};

export const LocationAddressCard = (props: LocationAddressCardProps) => {
  const { address, phoneNumbers } = props;

  const renderPhoneNumbers = useMemo(() => {
    if (!phoneNumbers.length) {
      return <Typography>{NO_DATA_PLACEHOLDER}</Typography>;
    }

    return (
      <Stack>
        {phoneNumbers?.map((phoneNumber) => (
          <Typography key={phoneNumber}>{formatPhoneNumberNationalForUS(phoneNumber)}</Typography>
        ))}
      </Stack>
    );
  }, [phoneNumbers]);

  return (
    <>
      <Grid item xs={12} md={4}>
        <InfoField
          sx={{ m: 0 }}
          label='Site Address'
          value={formatFullAddress(address)}
          noDataMessage=''
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <Typography variant='body2' color='textSecondary' gutterBottom>
          Site Phone Number
        </Typography>
        {renderPhoneNumbers}
      </Grid>
    </>
  );
};
